import { InputRequestValue, GroupedMessage } from "@/components/active-session/types";
import { SessionEventObservable } from "@/store/sessions/SessionEventObservable";

export const getNextInputRequestValue = (
  events: SessionEventObservable[]
): InputRequestValue | undefined => {
  let openRequest: InputRequestValue | undefined = undefined;

  const inputRequestEvents = events.filter(event => event.kind === "INPUT_REQUESTED");

  for (const inputRequestEvent of inputRequestEvents) {
    if (
      events.some(e => {
        if (e.kind === "INPUT_PROVIDED") {
          return e.eventValue.request_id === inputRequestEvent.eventValue.id;
        } else {
          return false;
        }
      }) === false
    ) {
      openRequest = inputRequestEvent.eventValue as InputRequestValue;
      break;
    }
  }

  return openRequest;
};

export const groupUpMessageEventsByType = (
  messageEvents: SessionEventObservable[]
): GroupedMessage[] => {
  const groupedMessages: GroupedMessage[] = [];
  let currentReasoningGroup: SessionEventObservable[] = [];

  messageEvents.forEach(event => {
    if (event.eventValue.kind === "REASONING") {
      currentReasoningGroup.push(event);
    } else {
      if (currentReasoningGroup.length > 0) {
        groupedMessages.push({
          type: "reasoning_group",
          events: [...currentReasoningGroup],
        });
        currentReasoningGroup = [];
      }
      groupedMessages.push({
        type: "single",
        event,
      });
    }
  });

  // Add any remaining reasoning events
  if (currentReasoningGroup.length > 0) {
    groupedMessages.push({
      type: "reasoning_group",
      events: [...currentReasoningGroup],
    });
  }

  return groupedMessages;
};
